import React from 'react';
import styled from 'styled-components';
import { useSelector } from 'react-redux';

const StyledToggleComponent = styled.input`
  --width: 45px;

  position: relative;
  width: var(--width);
  height: calc(var(--width) / 2);
  appearance: none;
  background-color: #c6c6c6;
  border-radius: 25px;
  box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.1);
  cursor: pointer;
  transition: 0.3s;
  
  &:checked {
    background-color: ${props => props.$primaryColor};
  }
  
  &:before {
    content: '';
    position: absolute;
    aspect-ratio: 1;
    inset-block: 2px;
    border-radius: 50%;
    top: 2px;
    left: 2px;
    background-color: #fff;
    transition: 0.3s;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
  }
  
  &:checked:before {
    left: calc(var(--width) - var(--width) / 2 + 2px);
  }
  
  &:focus {
    outline: none;
    box-shadow: 0 0 0 2px ${props => props.$primaryColor}33;
  }
`;

export const StyledToggle = (props) => {
  const systemConfiguration = useSelector((state) => state.systemConfiguration);

  return (
    <StyledToggleComponent
      {...props}
      $primaryColor={systemConfiguration.primary_color}
    />
  );
};